var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonthlyEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "45px",
    viewBox: "0 0 52 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AC8C9464-2284-4BDA-AC02-744134A6E34B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.504882812
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Monthly-Check-in---Empty",
    transform: "translate(-694.000000, -606.000000)",
    fill: "#9C9C9C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monthly-empty",
    transform: "translate(694.000000, 606.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49443902,35.9217938 L40.6093171,35.9217938 C40.9601375,35.9217938 41.299184,35.7990665 41.5680865,35.5752639 C41.9438514,35.260663 50.5138071,27.8882461 51.0364457,11.9739113 L9.02779823,11.9739113 C8.50725499,26.4199091 0.614694013,33.2098204 0.532676275,33.2776696 C0.0518447894,33.683867 -0.125062084,34.347592 0.0912572062,34.9381796 C0.306079823,35.5271707 0.865935698,35.9217938 1.49443902,35.9217938",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5896109,2.99345787 L42.1059412,2.99345787 L42.1059412,1.49678381 C42.1059412,0.658546563 41.4473049,9.97782707e-06 40.6091674,9.97782707e-06 C39.7710299,9.97782707e-06 39.1123936,0.658546563 39.1123936,1.49678381 L39.1123936,2.99345787 L31.5289457,2.99345787 L31.5289457,1.49678381 C31.5289457,0.658546563 30.8704091,9.97782707e-06 30.0321718,9.97782707e-06 C29.1940344,9.97782707e-06 28.5354978,0.658546563 28.5354978,1.49678381 L28.5354978,2.99345787 L21.0517284,2.99345787 L21.0517284,1.49678381 C21.0517284,0.658546563 20.3931918,9.97782707e-06 19.5550543,9.97782707e-06 C18.7168171,9.97782707e-06 18.0582805,0.658546563 18.0582805,1.49678381 L18.0582805,2.99345787 L10.5746109,2.99345787 C9.73647339,2.99345787 9.07783703,3.65199446 9.07783703,4.49013193 L9.07783703,8.98045344 L51.0863847,8.98045344 L51.0863847,4.49013193 C51.0863847,3.65199446 50.4277483,2.99345787 49.5896109,2.99345787",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4901752,37.870204 C42.6774812,38.5469002 41.6573481,38.9153814 40.6092772,38.9153814 L9.07794678,38.9153814 L9.07794678,43.4056031 C9.07794678,44.2329645 9.7473592,44.9023769 10.5747206,44.9023769 L49.5897206,44.9023769 C50.417082,44.9023769 51.0864945,44.2329645 51.0864945,43.4056031 L51.0864945,26.6274878 C48.2008071,33.7071552 44.1739557,37.2979756 43.4901752,37.870204",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyEmpty);
export default __webpack_public_path__ + "static/media/monthly-empty.44ec4a2d.svg";
export { ForwardRef as ReactComponent };